import _intersection from 'lodash/intersection';

export const isActivityHistoryEnabled = (
  lender?: {
    inspectionConfig?: { hasActivityHistory?: boolean | null } | null;
  } | null
) => lender?.inspectionConfig?.hasActivityHistory === true;

export type InitialInspectionSection = {
  step: string;
  panel: string;
};

const SELLER_ID_DOCUMENT_TYPES = [
  'SELLER_ID',
  'DRIVER_LICENCE_FRONT',
  'DRIVER_LICENCE_BACK',
  'FACE'
];

const VEHICLE_DOCUMENT_TYPES = [
  'VIN',
  'REGO_PLATE',
  'ODOMETER',
  'ASSET_FRONT',
  'ASSET_BACK',
  'ASSET_LEFT',
  'ASSET_RIGHT',
  'INTERNAL_FRONT',
  'INTERNAL_BACK',
  'INTERNAL_BOOT',
  'INTERNAL_LIVING_AREA',
  'INTERNAL_KITCHEN',
  'INTERNAL_SLEEPING_AREA',
  'OPERATING_HOURS'
];

const DRIVER_LICENCE_SECTION: InitialInspectionSection = {
  step: '1',
  panel: 'DRIVER_LICENCE_FRONT'
};

export const getInitialInspectionSection = (
  documentTypes?: string[] | null
): InitialInspectionSection => {
  const docTypes = documentTypes ?? [];

  if (docTypes.length === 0) {
    return DRIVER_LICENCE_SECTION;
  }

  if (_intersection(docTypes, SELLER_ID_DOCUMENT_TYPES).length > 0) {
    return DRIVER_LICENCE_SECTION;
  }

  if (_intersection(docTypes, VEHICLE_DOCUMENT_TYPES).length > 0) {
    return { step: '2', panel: 'VIN' };
  }

  if (docTypes.includes('REGO_PAPERS')) {
    return { step: '3', panel: 'regoPaper' };
  }

  if (docTypes.includes('BANK_STATEMENTS')) {
    return { step: '4', panel: 'bank' };
  }

  if (
    docTypes.includes('ROADWORTHY_CERT') ||
    docTypes.includes('SAFETY_CERT')
  ) {
    return { step: '5', panel: 'cert' };
  }

  if (docTypes.includes('PAYOUT_LETTER')) {
    return { step: '6', panel: 'payoutLetter' };
  }

  if (docTypes.includes('OWNERSHIP_PROOF')) {
    return { step: '7', panel: 'ownershipProof' };
  }

  return DRIVER_LICENCE_SECTION;
};
